import type { Worflow } from './ElectronicSignatureWorkflowDialog.types';

export const WORKFLOW_TYPES: Record<Worflow, Worflow> = {
  CREATION: 'CREATION',
  RECOVERY: 'RECOVERY',
};
